import $ from 'jquery'

window.submitHubspotForm = function (email) {
    var fields = [
        {name: 'email', value: email},
    ]

    const portalID = 6376403
    const formGUID = 'e4f259ee-478b-40a5-9e96-5466080a7253'
    const apiToken = 'ce755a31-4011-46d3-bbce-4a44d080fe81'

    return $.ajax({
        url: `https://api.hsforms.com/submissions/v3/integration/submit/${portalID}/${formGUID}?hapikey=${apiToken}`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8'
        },
        data: JSON.stringify({fields})
    });
}
